import React from "react";
import { Box } from "@mui/material";

function LocationMap() {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "24px",
        overflow: "hidden",
        boxShadow: "0 20px 45px rgba(0,0,0,0.12)",
        marginTop: 4,
      }}
    >
      <iframe
        title="Zencon Limited Co."
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3552.749592741371!2d49.54624207544502!3d27.06965097655401!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjfCsDA0JzEwLjciTiA0OcKwMzInNTUuNyJF!5e0!3m2!1sen!2ssa!4v1778397013832!5m2!1sen!2ssa"
        width="100%"
        height="250"
        style={{
          border: 0,
        }}
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </Box>
  );
}

export default LocationMap;
